export default "__VITE_ASSET__COI1w4iw__"